export default {
  SAE: 'SAE',
  ISO: 'ISO',
  NA: 'NA',
  NAId: 0
};
